import * as React from "react";
import Layout from "../components/layout";
import EnrolmentContent from "../components/enrolment/enrolmentContent";
import BannerImage from "../components/master/BannerImage";
import heroImage from "../assets/enrolment/enrolment-hero-image.jpg";

const EnrolmentPage = () => {
  return (
    <Layout>
      <BannerImage imagePath={heroImage} altText="..." />
      <EnrolmentContent />
    </Layout>
  );
};

export default EnrolmentPage;
